'use client'

import { Icon } from '@/components'

import styles from './Controller.module.scss'

const CONTROLLER_DATA = {
  left: {
    icon: 'arrow-left',
    id: 'carouselPrevious',
    ariaLabel: 'Voltar para o item anterior'
  },
  right: {
    icon: 'arrow-right',
    id: 'carouselNext',
    ariaLabel: 'Avançar para o próximo item'
  }
}

export const Controller = ({
  section,
  direction,
  variant,
  disabled,
  onClick
}) => {
  const controllerData = CONTROLLER_DATA[direction]

  return (
    <button
      disabled={disabled}
      aria-label={controllerData.ariaLabel}
      id={`${section}-${controllerData.id}-button`}
      className={`
        ${styles.controller} 
        ${styles[`controller--${variant}`]}
      `}
      onClick={() => onClick(direction)}
    >
      <Icon size="xs" name={controllerData.icon} />
    </button>
  )
}
